import React, { Component, Fragment } from 'react';
import {
  Container,
  Row, Col, Input, Button, Form, FormGroup
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import Marketing2Textarea from './Marketing2Textarea';
import Marketing2Attachments from './Marketing2Attachments';
import ConfirmButton from '../Modal/ConfirmButton';
class Marketing2Invitations extends Component {

  constructor(props) {
    super(props);
    this.input = React.createRef();
    this.state = {
      value: null,
      selectionStart: null
    };
  }

  formatDate = (d) => {
    if (parseInt(String(d).substring(0, 4)) <= 2000) return "";
    return parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10)) + '/' + parseInt(String(d).substring(0, 4));
  }

  standardRow = (invitation) => {
    return (
      <Row className="adminRow pointer text-left" onClick={() => this.props.onEdit(invitation.ID)}>
        <Col md={4}>{invitation.Name}</Col>
        <Col md={4}>{invitation.Type}</Col>
        <Col md={4}>{this.formatDate(invitation.Date)}</Col>
      </Row>
    )
  }

  editRow = (invitation) => {
    return (
      <Row className="editRow adminRow">
        <Col md={8} className="text-left">
          <Form inline>
            <FormGroup className="mr-2">
              <Input
                placeholder="Name"
                name="name"
                value={this.props.editInvitation.name + ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                type="select"
                name="invitationTypeID"
                value={this.props.editInvitation.invitationTypeID}
                onChange={e => this.props.onChange(e, 'edit')}>
                <option value={0}>Type</option>
                {this.props.types.map(type => (
                  <option key={type.TypeID} value={type.TypeID}>{type.Type}</option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                type="Date"
                name="date"
                value={String(this.props.editInvitation.date).substring(0, 10) + ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
          </Form>
          <Marketing2Textarea
            value={this.props.editInvitation.description}
            placeholder="Description"
            name="description"
            onChange={this.props.onChange}
            edit={true}
          />
        </Col>
        <Col md={4} className="text-right">
          <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Invitation">
            <FontAwesomeIcon icon={faCheck} />
          </Button>
          <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(invitation.ID)} edit="Delete Invitation">
            <FontAwesomeIcon icon={faTrashAlt} />
          </ConfirmButton>
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
          <Marketing2Attachments
            attachments={this.props.editInvitation.attachments.map(attachment => attachment.FileID)}
            onChange={this.props.onChange}
            edit={true}
            files={this.props.files}
            handleRemoveAttachment={this.props.handleRemoveAttachment}
          />
        </Col>
      </Row>
    )
  }


  addRow = () => {
    return (
      <Row className="py-4 text-left align-items-bottom ">
        <Col md={8}>
          <Form inline>
            <FormGroup className="pr-2">
              Add New Invitation
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                placeholder="Invitation Template Name"
                name="name"
                value={this.props.newInvitation.name + ''}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                type="select"
                name="invitationTypeID"
                value={this.props.newInvitation.invitationTypeID}
                onChange={e => this.props.onChange(e)}>
                <option value={0}>Type</option>
                {this.props.types.map(type => (
                  <option key={type.TypeID} value={type.TypeID}>{type.Type}</option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                type="Date"
                name="date"
                value={this.props.newInvitation.date + ''}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
          </Form>
          <Marketing2Textarea
            value={this.props.newInvitation.description}
            placeholder="Description"
            name="description"
            onChange={this.props.onChange}
            edit={false}
          />
        </Col>
        <Col md={4} className="text-right">
          <Button
            disabled={this.props.newInvitation.name === '' || this.props.newInvitation.date === '' || this.props.newInvitation.description === '' || parseInt(this.props.newInvitation.invitationTypeID) === 0}
            color="primary"
            onClick={this.props.handleAdd}
          >Add Invitation</Button>
          <Marketing2Attachments
            attachments={this.props.newInvitation.attachments.map(attachment => attachment.FileID)}
            onChange={this.props.onChange}
            edit={false}
            files={this.props.files}
            handleRemoveAttachment={this.props.handleRemoveAttachment}
          />
        </Col>
      </Row>
    )
  }

  render() {
    return (
      <Container className="adminContainer" fluid>
        {this.props.invitations.map(invitation => (
          <Fragment key={invitation.ID}>{this.props.editInvitation.invitationID === invitation.ID ? this.editRow(invitation) : this.standardRow(invitation)}</Fragment>
        ))}
        {this.addRow()}
      </Container>
    );

  }
}

export default Marketing2Invitations;
